var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"render"},[_c('beagl-form',{attrs:{"renderForm":_vm.form,"displayTitle":_vm.displayTitle,"disableSubmit":_vm.disableSubmit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }